import React from 'react';

import { useDrawPaymentSchedule } from '@consumer-frontend/nc-api';

import { scheduledPaymentsErrorHeader, standardErrorMessage } from '../../store';
import { NcButtonStyledAsLink } from '../NcButtonStyledAsLink';
import { NcCard, NcCardHeading } from '../NcCard';
import { NcError } from '../NcError';
import { NcLoadingSpinner } from '../NcLoadingSpinner';
import { NcMinimumPaymentEstimations } from '../NcMinimumPaymentEstimations';
import { NcModalAnchor } from '../NcModal';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/draw-request/minimum-payment-estimator.scss';

export type NcMinimumPaymentEstimatorPropsT = {
  requestedAmount?: number;
};
export type NcMinimumPaymentEstimatorT = React.FC<NcMinimumPaymentEstimatorPropsT>;

const modalBody = (
  <div>
    <p>
      Minimum payment calculations are based on your current account details.
    </p>
    <p>
      These estimates assume you make your minimum payments on time and remain current.
    </p>
    <p>
      If you request another cash advance, schedule additional payments, or adjust a due date,
      your estimated minimum payments will be recalculated.
    </p>
  </div>
);

export const NcMinimumPaymentEstimator: NcMinimumPaymentEstimatorT = ({ requestedAmount }) => {
  const {
    error,
    isLoading,
    minimumPayments,
  } = useDrawPaymentSchedule({ requestedAmount });

  const showLoadingSpinner = isLoading && !error;
  const hasError = !isLoading && !!error;
  const showInvalidAmountAlert = !requestedAmount;

  return (
    <NcCard className="nc-minimum-payment-estimator">
      <NcCardHeading level={2} className="h3 semi-bold">Minimum Payment Estimator</NcCardHeading>

      <p>
        These estimates are based on the cash advance amount you select.{' '}

        <NcModalAnchor
          body={modalBody}
          title="Minimum Payment Estimator"
          primaryText="Close"
        >
          <NcButtonStyledAsLink>How minimum payments are calculated.</NcButtonStyledAsLink>
        </NcModalAnchor>
      </p>

      {/* TODO: use alert once error messaging finalized (NCHY-16) */}
      {/* {showInvalidAmountAlert && <NcAlert variant="warning">Requested amount is invalid.</NcAlert>} */}

      {(showInvalidAmountAlert || showLoadingSpinner) && <NcLoadingSpinner />}

      {hasError && (
        <NcError
          className="w-100"
          header={scheduledPaymentsErrorHeader}
          message={standardErrorMessage}
        />
      )}

      <NcMinimumPaymentEstimations minimumPayments={minimumPayments} />

    </NcCard>
  );
};
